import { Wheat, Milk, Cookie, SprayCan, Flame, Package } from "lucide-react";

export const CATEGORIES = [
  { key: "all", label: "All Essentials", testid: "category-tab-all" },
  { key: "groceries", label: "Groceries & Pulses", testid: "category-tab-groceries" },
  { key: "dairy", label: "Dairy & Fresh Milk", testid: "category-tab-dairy" },
  { key: "snacks", label: "Snacks & Namkeen", testid: "category-tab-snacks" },
  { key: "household", label: "Household & Cleaning", testid: "category-tab-household" },
  { key: "spices", label: "Spices & Oils", testid: "category-tab-spices" },
];

export const CATEGORY_META = {
  groceries: { label: "Groceries & Pulses", icon: Wheat, bg: "bg-[#E8F5E9]", fg: "text-[#1B5E20]" },
  dairy: { label: "Dairy & Fresh Milk", icon: Milk, bg: "bg-[#FFF3E0]", fg: "text-[#E65100]" },
  snacks: { label: "Snacks & Namkeen", icon: Cookie, bg: "bg-[#FEF9C3]", fg: "text-[#854D0E]" },
  household: { label: "Household & Cleaning", icon: SprayCan, bg: "bg-[#E0F2F1]", fg: "text-[#00695C]" },
  spices: { label: "Spices & Oils", icon: Flame, bg: "bg-[#FFEDD5]", fg: "text-[#9A3412]" },
};

export const categoryIcon = (key) => (CATEGORY_META[key] || { icon: Package }).icon;

export const STORE = {
  name: "Shivam Kirana Store",
  owner: "Atul Kashyap",
  email: "atulkashyapjai@gmail.com",
  phone: "6393821776",
  phoneIntl: "+91 63938 21776",
  whatsapp: "https://wa.me/916393821776?text=Namaste!%20I%20would%20like%20to%20place%20an%20order.",
  address: "Main Market Road, Civil Lines, Kanpur, Uttar Pradesh",
  hours: "Monday – Sunday · 7:00 AM – 10:00 PM",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1611693424421-3db00de93a89?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  market: "https://images.unsplash.com/photo-1775677073681-194049b1a7d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  spices: "https://images.unsplash.com/photo-1698976538178-b60041b86cea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  snacks: "https://images.unsplash.com/photo-1789016862368-f0e081ed0167?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
};
